export const resendCodeButtonData = {
  text: {
    default: 'Send new code via {contactInfo}',
    timeout: 'Send new code via {contactInfo} in {countdown}s'
  }
};
